import React from 'react';
import InstitucionalFrame from './InstitucionalFrame';

const InstitucionalGestao: React.FC = () => (
  <InstitucionalFrame page="gestao.html" title="InPlay Gestão" />
);

export default InstitucionalGestao;
